<template>
  <div id="segment-list">
    <b-modal
      id="segment-list-modal"
      size="xl"
      :noCloseOnBackdrop="true"
      :noCloseOnEsc="true"
      @shown="loadMore"

    >
      <template v-slot:modal-header>
        <h5 class="title">
          {{ getModalTitle }}
        </h5>
        <div id ="close-modal-segment-list" class="gjs-mdl-btn-close" style="top: 0.25em!important;" @click="cancel" data-close-modal="">x</div>
      </template>
      <div>
        <div class="section-segment">
          <b-row class="mb-2 mx-1 d-flex justify-content-between">
            <b-col
              class="section-segment__title"
              v-if="
                nbrCall === 1 &&
                  !editMode &&
                  $route.params.type !== 'NewSegment' &&
                  $route.params.type !== 'EditSegment'
              "
            >
              <b-form-group>
                <b-form-input
                  id="input-titre"
                  :placeholder="$t('panels.newSegment')"
                  autofocus
                  v-model="titleSegment"
                  :maxlength="getmaxLength"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
        </div>
        <slide-card
          :class="{
            disabled:
              selected.length >= permission.nb_screen_segment &&
              !selectedIds.includes(emptyDisposition.id) &&
              getNbSreenSegment,
          }"
          :isEditable="false"
          :isHover="false"
          :item="emptyDisposition"
          :isSelected="selectedIds.includes(emptyDisposition.id)"
          @selected="select(emptyDisposition)"
        ></slide-card>
        <div class="section-disposition section-disposition__title">
          <span>{{ $t('labels.models') }}</span>
        </div>
        <div class=" slides-carousel">
          <carousel
            navigation-prev-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
            navigation-next-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
            :mouse-drag="false"
            :navigation-enabled="true"
            :pagination-enabled="false"
            @pageChange="pageChanged('Disposition')"
            :per-page-custom="[[320, 1], [576, 2], [768, 2], [992, 4], [1200, 4]]"
          >
            <slide v-for="item in dispositions" :key="item.uid" class="one-disposition">
              <slide-card
                :class="{
                  disabled:
                    selected.length >= permission.nb_screen_segment &&
                    !selectedIds.includes(item.id) &&
                    getNbSreenSegment,
                }"
                :Shot="item.screenShot ? item.screenShot : null"
                :isHover="false"
                :item="item"
                :isSelected="selectedIds.includes(item.id)"
                @selected="select(item)"
              ></slide-card>
            </slide>
          </carousel>
        </div>
        <div v-show="AllScreens.length > 0" class="section-screen section-screen__title">
          <span>{{ $t('labels.recent') }}</span>
        </div>

        <div class=" slides-carousel" v-show="AllScreens.length !== 0">
          <carousel
            navigation-prev-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC41MzEgNDQ0LjUzMSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjUzMSA0NDQuNTMxOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTIxMy4xMywyMjIuNDA5TDM1MS44OCw4My42NTNjNy4wNS03LjA0MywxMC41NjctMTUuNjU3LDEwLjU2Ny0yNS44NDFjMC0xMC4xODMtMy41MTgtMTguNzkzLTEwLjU2Ny0yNS44MzUgICBsLTIxLjQwOS0yMS40MTZDMzIzLjQzMiwzLjUyMSwzMTQuODE3LDAsMzA0LjYzNywwcy0xOC43OTEsMy41MjEtMjUuODQxLDEwLjU2MUw5Mi42NDksMTk2LjQyNSAgIGMtNy4wNDQsNy4wNDMtMTAuNTY2LDE1LjY1Ni0xMC41NjYsMjUuODQxczMuNTIxLDE4Ljc5MSwxMC41NjYsMjUuODM3bDE4Ni4xNDYsMTg1Ljg2NGM3LjA1LDcuMDQzLDE1LjY2LDEwLjU2NCwyNS44NDEsMTAuNTY0ICAgczE4Ljc5NS0zLjUyMSwyNS44MzQtMTAuNTY0bDIxLjQwOS0yMS40MTJjNy4wNS03LjAzOSwxMC41NjctMTUuNjA0LDEwLjU2Ny0yNS42OTdjMC0xMC4wODUtMy41MTgtMTguNzQ2LTEwLjU2Ny0yNS45NzggICBMMjEzLjEzLDIyMi40MDl6IiBmaWxsPSIjYTZhNmE2Ii8+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg=='/></span>"
            navigation-next-label="<span><img src='data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTYuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjE2cHgiIGhlaWdodD0iMTZweCIgdmlld0JveD0iMCAwIDQ0NC44MTkgNDQ0LjgxOSIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDQ0LjgxOSA0NDQuODE5OyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnPgoJPHBhdGggZD0iTTM1Mi4wMjUsMTk2LjcxMkwxNjUuODg0LDEwLjg0OEMxNTkuMDI5LDMuNjE1LDE1MC40NjksMCwxNDAuMTg3LDBjLTEwLjI4MiwwLTE4Ljg0MiwzLjYxOS0yNS42OTcsMTAuODQ4TDkyLjc5MiwzMi4yNjQgICBjLTcuMDQ0LDcuMDQzLTEwLjU2NiwxNS42MDQtMTAuNTY2LDI1LjY5MmMwLDkuODk3LDMuNTIxLDE4LjU2LDEwLjU2NiwyNS45ODFsMTM4Ljc1MywxMzguNDczTDkyLjc4NiwzNjEuMTY4ICAgYy03LjA0Miw3LjA0My0xMC41NjQsMTUuNjA0LTEwLjU2NCwyNS42OTNjMCw5Ljg5NiwzLjUyMSwxOC41NjIsMTAuNTY0LDI1Ljk4bDIxLjcsMjEuNDEzICAgYzcuMDQzLDcuMDQzLDE1LjYxMiwxMC41NjQsMjUuNjk3LDEwLjU2NGMxMC4wODksMCwxOC42NTYtMy41MjEsMjUuNjk3LTEwLjU2NGwxODYuMTQ1LTE4NS44NjQgICBjNy4wNDYtNy40MjMsMTAuNTcxLTE2LjA4NCwxMC41NzEtMjUuOTgxQzM2Mi41OTcsMjEyLjMyMSwzNTkuMDcxLDIwMy43NTUsMzUyLjAyNSwxOTYuNzEyeiIgZmlsbD0iI2EwYTBhMCIvPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+CjxnPgo8L2c+Cjwvc3ZnPgo='/></span>"
            :mouse-drag="false"
            :navigation-enabled="true"
            :pagination-enabled="false"
            @pageChange="pageChanged('Screen')"
            :per-page-custom="[[320, 1], [576, 2], [768, 3], [992, 4], [1200, 4]]"
          >
            <slide v-for="item in AllScreens" :key="item.uid" class="one-screen">
              <slide-card
                :class="{
                  disabled:
                    selected.length >= permission.nb_screen_segment &&
                    !selectedIds.includes(item.id) &&
                    getNbSreenSegment,
                }"
                :item="item"
                :Shot="item.screenShot ? item.screenShot : null"
                :isSelected="selectedIds.includes(item.id)"
                @selected="select(item)"
              ></slide-card>
            </slide>
          </carousel>
        </div>
      </div>
      <template v-slot:modal-footer>
        <button class="btn btn-link" @click="cancel" v-if="nbrCall > 1 || editMode">
          {{ $t('button.cancel') }}
        </button>
        <button class="btn btn-primary" v-if="nbrCall === 1 && !editMode" @click="back">
          {{ $t('button.back') }}
        </button>
        <button class="btn btn-primary" @click="confirm" :disabled="ButtonDisabled">
          {{ $t('button.confirm') }}
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import en from '../../i18n/en_US';
import fr from '../../i18n/fr_FR';
import SlideCard from './SlideCard';
import mixin from '../../mixins/Mixin.js';
import { Carousel, Slide } from 'vue-carousel';
import mixinGrapesHelpers from '../../mixins/GrapesMixinHelpers';
import * as durationHelper from '../../helpers/duration-handler';

export default {
  name: 'SegmentList',
  mixins: [mixin, mixinGrapesHelpers],

  data() {
    return {
      ButtonDisabled: true,
      selectedTab: '',
      nbreScreens: 1,
      infiniteState: null,
      selectedIds: [],
      total: 0,
      titleModal: '',
      titleSegment: '',
    };
  },
  components: {
    SlideCard,
    Carousel,
    Slide,
  },
  i18n: {
    messages: {
      en: en,
      fr: fr,
    },
  },
  created() {
    eventHub.$on('resetModalSegmentList', this.reset);
  },
  mounted() {
    this.showTab('Disposition');
    this.titleSegment = this.$t('panels.newSegment');
  },
  watch: {},
  computed: {
    ...mapGetters({
      getmaxLength: 'common/getmaxLength',
      AllScreens: 'slides/getAllScreens',
      currentSlide: 'slides/getCurrent',
      dispositions: 'slides/getAllDispositions',
      isLoading: 'slides/getLoading',
      isEndReached: 'slides/getEndReached',
      selected: 'slides/getSelected',
      isSelected: 'slides/isSelected',
      firstSelectedSlide: 'slides/getLastSlideById',
      showIconSave: 'common/getShowIconSave',
      paramsClient: 'getParamsClients',
      totalDurationScreens: 'slides/getAllScreensDuration',
      nbrCall: 'segments/getNbrCall',
      permission: 'getPermissions',
      lastUpdatedSegment: 'segments/getLastUpdatedSegmentById',
    }),
    confirmButtonDisabled() {
      return this.$route.name === 'segment' ? this.selected.length === 0 : false;
    },
    editMode() {
      return this.$route.name === 'edit';
    },
    getModalTitle() {
      if (this.$route.name === 'edit') {
        this.titleModal = this.$t('panels.addNewScreen');
      } else if (
        this.$route.params.type === 'NewSegment' ||
        this.$route.params.type === 'EditSegment'
      )
        this.titleModal = this.$t('panels.addNewScreen');
      else {
        this.nbrCall === 1
          ? (this.titleModal = this.$t('panels.addNewSegment'))
          : (this.titleModal = this.$t('panels.addNewScreen'));
      }
      return this.titleModal;
    },
    emptyDisposition() {
      var disposition = {
        assets: '',
        components: '',
        css: '',
        html: '',
        options: {
          duration: durationHelper.totalSegmentDuration(),
        },
        styles: '',
        title: this.$t('disposition.empty'),
        transition: {
          in: '',
          out: '',
        },
        type: 'Disposition',
        screenShot:
          'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJAQMAAAAB5D5xAAAABlBMVEXs7vHs7/Hee24nAAAAFUlEQVQI12P4/58BiGrB5D8wCUX/AOfxEWuWlIcVAAAAAElFTkSuQmCC',
        id: 0,
      };
      return disposition;
    },
  },
  methods: {
    ...mapActions('slides', [
      'paginate',
      'selectSlide',
      'setCurrentSlide',
      'removeLastSlideById',
      'updateSlide',
      'fetch',
      'resetSelect',
      'changeTitleInSelected',
    ]),
    ...mapActions('common', ['setShowIconSave']),
    ...mapActions('segments', [
      'setfromRouteAdd',
      'resetNbCall',
      'setCurrentSegment',
      'setNbrCall',
      'appendSlideToSegment',
      'removeLastSlideFromSegmentById',
      'updateSlideInsideSegment',
    ]),
    ...mapActions(['setRoute']),
    back() {
      this.selectedIds.forEach(id => {
        this.removeLastSlideById(id);
        this.removeLastSlideFromSegmentById(id);
      });
      this.$root.$emit('bv::hide::modal', 'segment-list-modal');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        iconSave.innerText = '';
      }

      if (this.$route.params.type === 'NewSegment') {
        this.setfromRouteAdd(true);
        this.$router.push({ name: 'EditSegment' });
      } else {
        this.setRoute('add');
        this.$router.push({ name: 'add' });
        this.$root.$emit('bv::show::modal', 'slide-list-modal');
      }

      this.selectedIds = [];
    },
    loadMore() {
      this.isShown = true;
    },
    showTab(tab) {
      this.selectedTab = tab;
    },
    select(item) {
      let limitAdd = this.getNbSreenSegment();
      let nb_screeen = this.permission.nb_screen_segment;
      let selected = JSON.parse(JSON.stringify(item));
      if (this.$route.name === 'segment') {
        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(i => i !== selected.id);
          this.removeLastSlideById(selected.id);
        } else {
          if (limitAdd && this.selected.length < nb_screeen) {
            this.selectedIds.push(selected.id);
            this.selectSlide(selected);
            this.ButtonDisabled = false;
          } else if (!limitAdd) {
            this.selectedIds.push(selected.id);
            this.selectSlide(selected);
            this.ButtonDisabled = false;
          }
        }
      } else {
        if (this.selectedIds.includes(selected.id)) {
          this.selectedIds = this.selectedIds.filter(i => i !== selected.id);
          this.removeLastSlideFromSegmentById(selected.id);
        } else {
          this.selectedIds.push(selected.id);
          this.appendSlideToSegment(selected);
          this.ButtonDisabled = false;
        }
      }
      if (this.selectedIds.length < 1) {
        this.ButtonDisabled = true;
      }
    },
    confirm() {
      const editor = grapesjsEMP.editors[0];
      var self = this;
      this.selected.map(s => (this.total += s.options.duration));

      // Segment
      const segment = {
        screensToSubmit: this.selected,
        duration: self.totalDurationScreens,
        uid: Math.floor(new Date().valueOf() * Math.random()),
      };
      let newSegment = Object.assign({}, segment, this.currentSegment);
      self.setCurrentSegment(newSegment);
      const psElement = document.getElementById('ps-slide-wrapper');
      try {
        const DraggableElement = document.getElementById('draggable-wrapper');
        psElement.scrollLeft = DraggableElement.offsetWidth;
      } catch (e) {}

      if (this.$route.name === 'segment') {
        // nb_screen_segment = 1 , on doit afficher le titre de segment dans le card et dans le panel
        let nb_screeen_param = this.paramsClient.nb_screen_segment;
        if (parseInt(nb_screeen_param) === 1) {
          this.changeTitleInSelected(
            this.titleSegment !== '' ? this.titleSegment : this.$t('panels.newSegment'),
          );
          this.setCurrentSlide(this.selectedIds[0]);
        }

        this.selectFirstSlide();
      } else if (this.selectedIds.length > 0) {
        console.log(this.lastUpdatedSegment);
        this.selectAddedSlide(
          this.lastUpdatedSegment,
          this.lastUpdatedSegment.screens[this.lastUpdatedSegment.screens.length - 1],
        );
      }

      this.selectedIds = [];
      this.$root.$emit('bv::hide::modal', 'segment-list-modal');
      var iconSave = document.querySelector('.icon-save');
      if (iconSave) {
        if (this.nbrCall === 1) {
          iconSave.classList.add('only-save');
        }
        iconSave.classList.add('icon-selected');
        this.setShowIconSave(true);
      }
      self.setNbrCall();
      //ButtonDisabled for the next call
      this.ButtonDisabled = true;
      ///new
      this.setNoAutoplayVideo(editor);
      let videoPlayers = ['player', 'playlist'];
      videoPlayers.forEach(player => {
        this.setPausedVideo(player);
      });
    },
    selectFirstSlide() {
      const lastSlide = {
        uid: this.currentSlide.uid,
        components: localStorage.getItem('gjs-components'),
        js: localStorage.getItem('gjs-js'),
        html: localStorage.getItem('gjs-html'),
        css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
        styles: localStorage.getItem('gjs-styles'),
      };
      this.updateSlide(lastSlide);

      this.generateSlideThmbnail(lastSlide.uid);
      const slide = this.firstSelectedSlide(this.selectedIds[0]);
      this.setCurrentSlide(slide);
      this.$root.$emit('updateCanvasContent');
    },
    selectAddedSlide(segment, slide) {
      if (segment.uid !== this.currentSegment.uid) {
        return;
      }
      const editor = grapesjsEMP.editors[0];
      const wrapper = editor.DomComponents.getWrapper();
      //editor.select(wrapper);
      setTimeout(() => {
        const lastSlide = {
          uid: this.currentSlide.uid,
          components: localStorage.getItem('gjs-components'),
          js: localStorage.getItem('gjs-js'),
          html: localStorage.getItem('gjs-html'),
          css: this.sanitizeCSS(localStorage.getItem('gjs-css')),
          styles: localStorage.getItem('gjs-styles'),
        };
        this.updateSlideInsideSegment(lastSlide);
        this.generateSlideThmbnail(this.currentSlide.uid);
        setTimeout(() => {
          //Set Current Screen
          this.setCurrentSlide(slide);
          //Set Current Segment by Screen
          this.setCurrentSegment(segment);

          this.$root.$emit('updateCanvasContent');
          this.setNoAutoplayVideo(editor);
          let videoPlayers = ['player', 'playlist'];
          videoPlayers.forEach(player => {
            this.setPausedVideo(player);
          });
          if (
            this.paramsClient.display_default_blocks &&
            Object.keys(this.paramsClient.display_default_blocks).length > 0
          ) {
            const blocks = document.querySelector(
              '#gjs .gjs-pn-buttons .fa-th-large:not(.gjs-pn-active)',
            );
            if (blocks) {
              blocks.click();
            }
          }
        }, 100);
      }, 100);
    },
    cancel() {
      this.selectedIds.forEach(id => {
        // remove select slide   ( add new segment  )
        this.removeLastSlideById(id);
        // remove select slide  ( panelpage : add screens to segment )
        this.removeLastSlideFromSegmentById(id);
      });
      if (this.nbrCall === 1 && !this.editMode) {
        this.$root.$emit('bv::hide::modal', 'segment-list-modal');
        this.setRoute('add');
        var iconSave = document.querySelector('.icon-save');
        if (iconSave) {
          iconSave.innerText = '';
        }
        this.$router.push({ name: 'add' });
        this.$root.$emit('bv::show::modal', 'slide-list-modal');
      } else {
        this.$root.$emit('bv::hide::modal', 'segment-list-modal');
      }

      // réinitialiser  selectedIds
      this.selectedIds = [];
    },
    reset() {
      this.resetNbCall();
      this.resetSelect();
      this.titleSegment = this.$t('panels.newSegment');
    },
    pageChanged(selectedTab) {
      const modal = document.getElementById('segment-list-modal');
      if (!modal || modal.style.display === 'none' || this.isLoading) {
        return;
      }
      let length;
      if (selectedTab === 'Screen') {
        length = this.AllScreens.length;
      } else {
        length = this.dispositions.length;
      }
      if (this.isEndReached(selectedTab) || !this.isShown) {
      }
      this.paginate(selectedTab);
    },
  },
  async mounted() {
    this.paginate('Disposition');
    this.paginate('Screen');

    if (this.$route.params.type === 'EditSegment') {
      this.setNbrCall(2);
    }
  },
};
</script>

<style lang="scss">
$primar-color: #2196f3;

#segment-list {
  .modal-body {
    padding: 20px 30px;
  }

  .slide {
    margin: 5px !important;
    max-width: 223px;
    &.disabled {
      cursor: not-allowed;
      opacity: 0.3;
      background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
      box-shadow: none;
      .title-screen {
        background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
        cursor: not-allowed;
        height: 4em;
      }
      .edit-title-btn {
        display: none;
      }
    }
  }

  .VueCarousel-navigation .VueCarousel-navigation-button :focus {
    outline: none !important;
  }
  .section-screen,
  .section-disposition {
    margin: 1em 0 1em 0;
    &__title {
      line-height: 0.5;
      text-align: center;
    }
    &__title span {
      display: inline-block;
      position: relative;
      /*text-transform: uppercase;*/
      font-size: 1.2em;
      font-weight: 400;
    }
    &__title span:before,
    &__title span:after {
      content: '';
      position: absolute;
      height: 5px;
      border-bottom: 1px solid #f0f0f0;
      top: 0;
      width: 410px;
    }
    &__title span:before {
      right: 100%;
      margin-right: 15px;
    }
    &__title span:after {
      left: 100%;
      margin-left: 40px;
    }
  }
  .section-segment {
    &__title {
      padding: 0;
    }
    #input-group-time .dropdown {
      position: absolute;
    }
  }
  //0 left 1 center
  .VueCarousel-slide {
    flex: 0 0 25%;
  }
  #segment-list-modal {
    color: #707070;
    &___BV_modal_header_ {
      background-color: $primar-color;
      color: #ffffff;
      border-radius: 0;
      .title {
        margin-bottom: 0;
      }
    }
    &___BV_modal_content_ {
      border-radius: 0;
    }
    &___BV_modal_footer_ {
      .btn-primary {
        background-color: $primar-color;
        border-color: $primar-color;
        border-radius: 0.1rem;
      }
      .btn-link {
        &:hover,
        &:focus {
          text-decoration: none;
        }
      }
    }
    .modal-dialog.modal-xl {
      max-width: 1000px !important;
    }
  }
}
.VueCarousel-navigation-button:focus {
  outline: none !important;
}
.VueCarousel-slide {
  visibility: visible;
  flex-basis: 100%;
  width: 100%;
}

  @media screen and (max-width: 900px) and (min-width:601px) {
    #segment-list .VueCarousel-slide {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 35% !important;
      flex: 0 0 35% !important;
    }
  }
  @media screen and (max-width: 600px) {
    #segment-list .VueCarousel-slide {
      -webkit-box-flex: 0;
      -ms-flex: 0 0 50% !important;
      flex: 0 0 50% !important;
    }  }






</style>



// WEBPACK FOOTER //
// SegmentList.vue?ddb5c5f8